const subUsersValidationPT = {
    "add": {
        "first_name": {
            "required": "Nome é obrigatório"
        },
        "last_name": {
            "required": "Sobrenome é obrigatório"
        },
        "email": {
            "required": "Email é obrigatório",
            "invalid": "Email não é válido",
            "unique": "Email está associado a outro usuário"
        },
        "username": {
            "required": "Nome de usuário é obrigatório",
            "stringCaseLower": "Nome de usuário deve estar em minúsculas",
            "regexp": "Nome de usuário deve consistir apenas de letras e números",
            "unique": "Nome de usuário está associado a outro usuário",
            "invalid": "Nome de usuário não é válido"
        },
        "password": {
            "required": "Senha é obrigatória",
            "regexp": "Senha deve consistir de pelo menos 10 caracteres, incluindo 1 letra maiúscula e 1 caractere especial"
        },
        "confirmPassword": {
            "required": "Por favor, confirme a senha",
            "identical": "Senha e confirmação de senha devem coincidir"
        },
        "contract_expiry": {
            "required": "Data de expiração do contrato é obrigatória"
        },
        "sub_user_deal": {
            "required": "Acordo de subusuário é obrigatório",
            "between": "Acordo de subusuário deve estar entre 0 e 100"
        },
        "street_and_number": {
            "required": "Rua e número da casa são obrigatórios"
        },
        "postal_code": {
            "required": "Código postal é obrigatório"
        },
        "city": {
            "required": "Cidade é obrigatória"
        },
        "country": {
            "required": "País é obrigatório"
        },
        "phone": {
            "required": "Número de telefone é obrigatório"
        }
    },
    "update": {
        "first_name": {
            "required": "Nome é obrigatório"
        },
        "last_name": {
            "required": "Sobrenome é obrigatório"
        },
        "email": {
            "required": "Email é obrigatório",
            "invalid": "Email não é válido"
        },
        "username": {
            "required": "Nome de usuário é obrigatório",
            "stringCaseLower": "Nome de usuário deve estar em minúsculas",
            "regexp": "Nome de usuário deve consistir apenas de letras e números"
        },
        "contract_expiry": {
            "required": "Data de expiração do contrato é obrigatória"
        },
        "sub_user_deal": {
            "required": "Acordo de subusuário é obrigatório",
            "between": "Acordo de subusuário deve estar entre 0 e 100"
        },
        "street_and_number": {
            "required": "Rua e número da casa são obrigatórios"
        },
        "postal_code": {
            "required": "Código postal é obrigatório"
        },
        "city": {
            "required": "Cidade é obrigatória"
        },
        "country": {
            "required": "País é obrigatório"
        },
        "phone": {
            "required": "Número de telefone é obrigatório"
        }
    }
};

export default subUsersValidationPT;